/* eslint-disable camelcase */
import classNames from 'classnames'
import React, { useState, useEffect } from 'react'

import { EditSquare } from '~/assets/icons/spark/edit-square'
import { useInBucket } from '~/hooks/use-in-bucket'
import { addNonBreakingSpaceToPostcode } from '~/utils/format-address'
import { getProviderNameFromId } from '~/utils/providers'
import { PROVIDERS } from '~/utils/providers-listing'
import { track, trackSegment } from '~/utils/tracking'

import { DisplayRow } from './display-row'
import styles from './index.module.css'
import { InputForm } from './input-form'
import { Spinner } from './spinner'

export const LandingForm = ({
  customerAddress = {},
  onUpdate,
  provider = '',
  isFetchingAddress,
  providersOverride
}) => {
  const [isEditingForm, setIsEditingForm] = useState(!customerAddress.summaryLine)
  const isBlackFriday = useInBucket('experiment-black-friday-2023', 'variant')

  // Handle the case where the address gets fetched from deeplink after initial render
  useEffect(() => {
    if (customerAddress.summaryLine) {
      setIsEditingForm(false)
    }
  }, [customerAddress])

  const updateSuccessHandler = async () => {
    await onUpdate()
    setIsEditingForm(false)
  }

  const editButtonClickHandler = () => {
    track('Broadband - Availability Checker', 'Edit details')
    trackSegment('Element Clicked', {
      element_name: 'Edit details',
      element_text: 'Edit details',
      element_type: 'button'
    })

    setIsEditingForm(true)
  }

  return (
    <div
      className={classNames(styles.formContainer, {
        [styles.blackFriday]: isBlackFriday
      })}
    >
      {isFetchingAddress && <Spinner />}

      {isEditingForm && (
        <InputForm
          customerAddress={customerAddress}
          onUpdate={updateSuccessHandler}
          provider={provider}
          providersOverride={providersOverride}
        />
      )}

      {!isEditingForm && !isFetchingAddress && (
        <>
          <DisplayRow title='Your address' text={addNonBreakingSpaceToPostcode(customerAddress?.summaryLine)} />
          <div className={styles.divider} />
          <DisplayRow title='Your provider' text={getProviderNameFromId(PROVIDERS, provider)} />
          <button onClick={editButtonClickHandler} className={styles.editButton}>
            <EditSquare className={styles.icon} />
            Edit details
          </button>
        </>
      )}
    </div>
  )
}
